'use client';

import AutoClickEvents from '@/components/analytics/AutoClickEvents.client';
import Leadfeeder from '@/components/analytics/Leadfeeder.client';
import ScrollDepth from '@/components/analytics/ScrollDepth.client';
import SectionViews from '@/components/analytics/SectionViews.client';

export default function Analytics() {
  return (
    <>
      <AutoClickEvents />
      <Leadfeeder />
      <SectionViews />
      <ScrollDepth />
    </>
  );
}
